import React, { useEffect, useState } from 'react';
import { Dialog } from 'primereact/dialog';
import './IECVideoModal.scss';
import { useNavigate } from 'react-router';
import { useSearchParams } from 'react-router-dom';
import { getIecData } from '../../Store/IECModule/IECModuleSelector';
import { useSelector } from 'react-redux';
import { useLanguage } from '../ChangeLanguage/LanguageProvider';


export default function IECVideoModal() {
  const [visible, setVisible] = useState(false);
  const [isPlaying, setIsPlaying] = useState(false);
  const [videoData, setVideoData] = useState(null);
  const { selectedLanguageId } = useLanguage();

  const handlePlayButtonClick = () => {
    const video = document.getElementById('videoPlayer');
    if (video) {
      try {
        video.play().then(() => {
          setIsPlaying(true);
        });
      } catch (error) {
        console.error('Error playing the video:', error);
      }
    }
  };

  const [serachParams] = useSearchParams();
  const iecDataId = serachParams.get('preview');

  const navigate = useNavigate();

  const fetchedData = useSelector(getIecData);
  useEffect(() => {
    if (iecDataId) {
      const id = parseInt(iecDataId);
      setVisible(true);
      setVideoData(fetchedData.find((data) => data.id === id));
    }
  }, [iecDataId, fetchedData]);

  const onHide = () => {
    setIsPlaying(false);
    setVisible(false);
    navigate('/iecmodule');
  };

  if (!videoData) return null;

  return (
    <Dialog
      className='video-main'
      header='Video Preview'
      data-testid='video-modal'
      visible={visible}
      onHide={onHide}
    >
      <div className='video-container'>
        <video
          id='videoPlayer'
          height='auto'
          controls={false}
          poster={videoData.thumbnail}
        >
          <source src={videoData.videoUrl} type='video/mp4' />
          Your browser does not support the video tag.
        </video>
        {!isPlaying && (
          <div
            data-testid='play-button'
            className='play-button'
            onClick={handlePlayButtonClick}
          ></div>
        )}
        <p className='m-0 mt-2 video-title'>{selectedLanguageId===1?videoData.videoTitle.english:videoData.videoTitle.marathi}</p>
        <p className='m-0 mt-2 video-description'>
          {videoData.videoDescription}
        </p>
      </div>
    </Dialog>
  );
}
